/* eslint-disable */

Drupal.behaviors.cardProjectDetails = {
  attach(context) {
    const cards = context.querySelectorAll('.card-project-details');

    if (cards.length > 0) {
      for (const card of cards) {
        const imgMain = card.querySelector('.card-project-details__image img');
        const imgs = card.querySelectorAll(
          '.card-project-details__content-gallery img',
        );

        console.log(imgs);

        for (const img of imgs) {
          img.addEventListener('click', (e) => {
            e.preventDefault();
            const mainImg = imgMain.src;
            const imgNow = img.src;
            imgMain.src = imgNow;
            img.src = mainImg;
          });
        }
      }
    }
  },
};
